import * as Types from '../../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ResourcesQueryVariables = {
  provingGroundId?: Types.Maybe<Types.Scalars['String']>
};


export type ResourcesQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'type' | 'legacyType' | 'category' | 'title' | 'inactive' | 'rootId' | 'abbr' | 'annotation' | 'notification' | 'unit' | 'costPerUnit' | 'color' | 'licensePlate' | 'chassisNumber' | 'tuevUntil' | 'tuevSweden' | 'origin' | 'destination' | 'location' | 'countryCode' | 'parentId' | 'external'>
    & { usageTimespans: Types.Maybe<Array<(
      { __typename?: 'UsageTimeSpan' }
      & Pick<Types.UsageTimeSpan, 'dateFrom' | 'dateTo'>
    )>>, parent: Types.Maybe<(
      { __typename?: 'Resource' }
      & Pick<Types.Resource, '_id' | 'rootId' | 'title' | 'category' | 'type'>
    )> }
  )>, resourceCategories: Array<(
    { __typename?: 'ResourceCategory' }
    & Pick<Types.ResourceCategory, '_id' | 'types'>
  )> }
);

export type AddResourceBookingMutationVariables = {
  provingId: Types.Scalars['ID'],
  input: Array<Types.ResourceBookingAddInput>
};


export type AddResourceBookingMutation = (
  { __typename?: 'Mutation' }
  & { addResourceBooking: Array<(
    { __typename?: 'ResourceBooking' }
    & Pick<Types.ResourceBooking, '_id'>
  )> }
);

export type UpdateResourceBookingMutationVariables = {
  provingId: Types.Scalars['ID'],
  batch: Array<Types.ResourceBookingBatchInput>
};


export type UpdateResourceBookingMutation = (
  { __typename?: 'Mutation' }
  & { updateResourceBooking: Array<(
    { __typename?: 'ResourceBooking' }
    & Pick<Types.ResourceBooking, '_id'>
  )> }
);

export type DeleteResourceBookingMutationVariables = {
  provingId: Types.Scalars['ID'],
  idsToDelete: Array<Types.Scalars['String']>
};


export type DeleteResourceBookingMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'deleteResourceBookings'>
);

export const ResourcesDocument = gql`
    query Resources($provingGroundId: String) {
  resources(filter: {rootId: {EQ: $provingGroundId}, category: {NIN: ["provingGround", "ferryConnection", "hotel"]}, inactive: {EQ: false}}) {
    _id
    type
    legacyType
    category
    title
    inactive
    rootId
    abbr
    annotation
    notification
    unit
    costPerUnit
    color
    licensePlate
    chassisNumber
    tuevUntil
    tuevSweden
    origin
    destination
    location
    countryCode
    parentId
    external
    usageTimespans {
      dateFrom
      dateTo
    }
    parent {
      _id
      rootId
      title
      category
      type
    }
  }
  resourceCategories {
    _id
    types
  }
}
    `;

    export function useResourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
      return ApolloReactHooks.useQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, baseOptions);
    };
      export function useResourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, baseOptions);
      };
      
export type ResourcesQueryHookResult = ReturnType<typeof useResourcesQuery>;
export type ResourcesQueryResult = ApolloReactCommon.QueryResult<ResourcesQuery, ResourcesQueryVariables>;
export const AddResourceBookingDocument = gql`
    mutation AddResourceBooking($provingId: ID!, $input: [ResourceBookingAddInput!]!) {
  addResourceBooking(provingId: $provingId, input: $input) {
    _id
  }
}
    `;
export type AddResourceBookingMutationFn = ApolloReactCommon.MutationFunction<AddResourceBookingMutation, AddResourceBookingMutationVariables>;

    export function useAddResourceBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddResourceBookingMutation, AddResourceBookingMutationVariables>) {
      return ApolloReactHooks.useMutation<AddResourceBookingMutation, AddResourceBookingMutationVariables>(AddResourceBookingDocument, baseOptions);
    };
export type AddResourceBookingMutationHookResult = ReturnType<typeof useAddResourceBookingMutation>;
export type AddResourceBookingMutationResult = ApolloReactCommon.MutationResult<AddResourceBookingMutation>;
export type AddResourceBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<AddResourceBookingMutation, AddResourceBookingMutationVariables>;
export const UpdateResourceBookingDocument = gql`
    mutation UpdateResourceBooking($provingId: ID!, $batch: [ResourceBookingBatchInput!]!) {
  updateResourceBooking(provingId: $provingId, batch: $batch) {
    _id
  }
}
    `;
export type UpdateResourceBookingMutationFn = ApolloReactCommon.MutationFunction<UpdateResourceBookingMutation, UpdateResourceBookingMutationVariables>;

    export function useUpdateResourceBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResourceBookingMutation, UpdateResourceBookingMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateResourceBookingMutation, UpdateResourceBookingMutationVariables>(UpdateResourceBookingDocument, baseOptions);
    };
export type UpdateResourceBookingMutationHookResult = ReturnType<typeof useUpdateResourceBookingMutation>;
export type UpdateResourceBookingMutationResult = ApolloReactCommon.MutationResult<UpdateResourceBookingMutation>;
export type UpdateResourceBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResourceBookingMutation, UpdateResourceBookingMutationVariables>;
export const DeleteResourceBookingDocument = gql`
    mutation DeleteResourceBooking($provingId: ID!, $idsToDelete: [String!]!) {
  deleteResourceBookings(provingId: $provingId, idsToDelete: $idsToDelete)
}
    `;
export type DeleteResourceBookingMutationFn = ApolloReactCommon.MutationFunction<DeleteResourceBookingMutation, DeleteResourceBookingMutationVariables>;

    export function useDeleteResourceBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteResourceBookingMutation, DeleteResourceBookingMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteResourceBookingMutation, DeleteResourceBookingMutationVariables>(DeleteResourceBookingDocument, baseOptions);
    };
export type DeleteResourceBookingMutationHookResult = ReturnType<typeof useDeleteResourceBookingMutation>;
export type DeleteResourceBookingMutationResult = ApolloReactCommon.MutationResult<DeleteResourceBookingMutation>;
export type DeleteResourceBookingMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteResourceBookingMutation, DeleteResourceBookingMutationVariables>;